var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaVerein(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#aeddf3;}.cls-3{fill:#eef5f8;}.cls-4{fill:#75b72d;}.cls-5{fill:#acd481;}.cls-6{fill:#fff;}.cls-7{fill:#057daa;}.cls-8{fill:#0098d1;}.cls-9{fill:#6dc8f2;}.cls-10{fill:none;mix-blend-mode:color;opacity:0.5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.41,8,36.33,80l44.08,72a72,72,0,0,0,0-144Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.41,80a72.08,72.08,0,0,0,72,72V8A72.08,72.08,0,0,0,8.41,80Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M80.41,16.44,41.5,80l38.91,63.56a63.56,63.56,0,0,0,0-127.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M16.85,80a63.63,63.63,0,0,0,63.56,63.56V16.44A63.63,63.63,0,0,0,16.85,80Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M80.41,41.75,57,80l23.42,38.25a38.25,38.25,0,0,0,0-76.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M42.16,80a38.29,38.29,0,0,0,38.25,38.25V41.75A38.29,38.29,0,0,0,42.16,80Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M106.34,65.29,95.41,54.24a29.69,29.69,0,0,0-15-4.05L63.05,80l17.36,29.81a29.69,29.69,0,0,0,15-4l10.93-11.05a29.82,29.82,0,0,0,0-29.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M65.41,54.24,54.49,65.29a29.76,29.76,0,0,0,0,29.42l10.73,10.93a29.61,29.61,0,0,0,15.19,4.17V50.19A29.72,29.72,0,0,0,65.41,54.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M124.47,64.52l8-2.79a55.19,55.19,0,0,0-52-36.85l-4.22,4.21,4.22,4.22A46.76,46.76,0,0,1,124.47,64.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M28.39,61.73l8,2.79A46.77,46.77,0,0,1,80.41,33.31V24.88A55.2,55.2,0,0,0,28.39,61.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M80.41,126.69l-4.22,4.22,4.22,4.22a55.2,55.2,0,0,0,52-36.86l-8-2.79A46.76,46.76,0,0,1,80.41,126.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M36.35,95.48l-8,2.79a55.21,55.21,0,0,0,52,36.86v-8.44A46.77,46.77,0,0,1,36.35,95.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M97.77,80l8.57,14.72a30,30,0,0,1-10.92,11L89.09,94.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M106.34,65.28,97.77,80,89.09,65.09l6.33-10.85A30,30,0,0,1,106.34,65.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "80.41 80 89.09 94.91 80.41 109.81 80.41 80"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "89.09 65.09 80.41 80 80.41 50.19 89.09 65.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "80.41 80 80.41 109.81 71.73 94.91 80.41 80"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "80.41 50.19 80.41 80 71.73 65.09 80.41 50.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.73,94.91l-6.32,10.85a29.91,29.91,0,0,1-10.93-11L63.05,80Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.41,54.24l6.32,10.85L63.05,80,54.48,65.28A29.91,29.91,0,0,1,65.41,54.24Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    width: 160,
    height: 160,
    rx: 8
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaVerein);
export default __webpack_public_path__ + "static/media/ka_verein.12c89c17e4ec9e1aa94860b1443bf841.svg";
export { ForwardRef as ReactComponent };